export class BalanceResponseApi {
  saldoTotalDisponivelCliente: number
  saldoRecomendadoDivisao: number

  public fromJSON(): BalanceResponse {
    const data: BalanceResponse = {
      saldoTotalDisponivelCliente: this.saldoTotalDisponivelCliente,
      saldoRecomendadoDivisao: this.saldoRecomendadoDivisao,
    }
    return Object.assign(new BalanceResponse(), data);
  }
}

export class BalanceResponse {
  saldoTotalDisponivelCliente: number
  saldoRecomendadoDivisao: number
}